import { render, staticRenderFns } from "./SelectInsurancePolicyParent.vue?vue&type=template&id=5a50a91a"
import script from "./SelectInsurancePolicyParent.vue?vue&type=script&lang=js"
export * from "./SelectInsurancePolicyParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports